import { useMemo } from 'react'

import type { NavigationData, UseCardNavigationParams } from '@/core/types/cardNavigation.type'

import { getClassNavigation, getLibraryNavigation, getRootNavigation } from './navigationLevels'

export function useCardNavigation({
  path,
  libraries,
  gateway,
  projectName,
  openAccordions = [],
  onAccordionToggle,
}: UseCardNavigationParams): NavigationData {
  return useMemo(() => {
    const [libraryName, className] = path

    // Root level: show all libraries
    if (!libraryName) {
      return getRootNavigation(libraries, gateway, projectName)
    }

    const library = libraries[libraryName]
    if (!library) {
      return getRootNavigation(libraries, gateway, projectName)
    }

    // Library level: show all classes
    if (!className) {
      return getLibraryNavigation(library, libraryName, gateway, projectName)
    }

    // Class level: show methods and constructors
    return getClassNavigation(library, libraryName, className, gateway, openAccordions, onAccordionToggle, projectName)
  }, [path, libraries, gateway, projectName, openAccordions, onAccordionToggle])
}
